import type { CSSObject, ThemeOptions } from "@mui/material/styles";

const sbMixins: ThemeOptions["mixins"] = {
  shadowPrimary10: "0px 4px 8px 0px #FF623433",
  shadowPrimary20: "0px 10px 18px 0px #FF62344D",
  shadowSurfaceLight10: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
  shadowSurfaceDark10: "0px 2px 4px 0px #000000",
  shadowSecondary20: "0px 10px 18px 0px #7B39D24D",
  shadowSecondary10: "0px 4px 8px 0px #7B39D233",
  textShadowSecondary20: "0px 0px 10px #7B39D24D",
  textShadowPrimary20: "0px 0px 10px #FF62344D",
  shadowAccentInfo20: "0px 4px 10px 0px #005D9766",
  shadowAccentWarning20: "0px 4px 10px 0px #B6841166",
  shadowAccentDanger20: "0px 4px 10px 0px #B4091F66",
  shadowAccentSuccess20: "0px 4px 10px 0px #3B7E3766",
};

declare module "@mui/material/styles" {
  interface Mixins {
    shadowPrimary10: string;
    shadowPrimary20: string;
    shadowSurfaceLight10: string;
    shadowSurfaceDark10: string;
    shadowSecondary20: string;
    shadowSecondary10: string;
    textShadowSecondary20: string;
    textShadowPrimary20: string;
    shadowAccentInfo20: string;
    shadowAccentWarning20: string;
    shadowAccentDanger20: string;
    shadowAccentSuccess20: string;
    cardContainer: CSSObject;
  }
}

export default sbMixins;
